import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";
import {StringUtils} from "src/constant/constants";

enableMapSet();

export interface ContactAlertFileMetadataState {
    dataToBePublished: any[],
    entityHeader: string,
    newBulkUploadFileAttributes: string[],
    existingBulkUploadFileAttributes: string[],
    isValidFileFormatForBulkUpload: boolean,
}

const initialContactAlertFileMetadataState: ContactAlertFileMetadataState = {
    dataToBePublished: [],
    entityHeader: StringUtils.EMPTY,
    newBulkUploadFileAttributes: [],
    existingBulkUploadFileAttributes: [],
    isValidFileFormatForBulkUpload: true,
};

/**
 * Slice for contact alert file metadata redux state.
 */
export const contactAlertFileMetadataComponentSlice = createSlice({
    name: 'contactAlertFileMetadataComponent',
    initialState: initialContactAlertFileMetadataState,
    reducers: {
        setDataToBePublished: (state, action: PayloadAction<any[]>) => {
            state.dataToBePublished = action.payload;
        },
        setEntityHeader: (state, action: PayloadAction<string>) => {
            state.entityHeader = action.payload;
        },
        setNewBulkUploadFileAttributes: (state, action: PayloadAction<string[]>) => {
            state.newBulkUploadFileAttributes = action.payload;
        },
        setExistingBulkUploadFileAttributes: (state, action: PayloadAction<string[]>) => {
            state.existingBulkUploadFileAttributes = action.payload;
        },
        resetFileMetadataState: (state, action: PayloadAction<void>) => {
            return initialContactAlertFileMetadataState;
        },
        setIsValidFileFormatForBulkUpload: (state, action: PayloadAction<boolean>) => {
            state.isValidFileFormatForBulkUpload = action.payload;
        }
    },
});

export const { setDataToBePublished,
    setEntityHeader,
    setNewBulkUploadFileAttributes,
    setExistingBulkUploadFileAttributes,
    resetFileMetadataState,
    setIsValidFileFormatForBulkUpload,
} = contactAlertFileMetadataComponentSlice.actions;
